import { useState } from 'react'
import {LogOut} from 'lucide-react'
import type { AuthUser } from '@/hooks/useAuth'
import { signOut } from '@/hooks/useAuth'
import { sanitizeBlockHtml } from '@/lib/sanitizeBlockHtml'

interface BlockedUserOverlayProps {
  user: AuthUser
}

export default function BlockedUserOverlay({ user }: BlockedUserOverlayProps) {
  const [acknowledged, setAcknowledged] = useState(false)
  const html = sanitizeBlockHtml(
    user.blockMessage ||
      '<p style="text-align:center;font-family:Georgia,serif">O seu acesso ao painel está bloqueado.</p>'
  )

  const handleLogout = () => {
    signOut()
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-zinc-950/85 p-3 backdrop-blur-sm sm:p-6">
      {acknowledged ? (
        <div className="w-full max-w-lg rounded-2xl border border-zinc-200 bg-white p-8 text-center shadow-2xl dark:border-zinc-800 dark:bg-zinc-950 sm:p-10">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-red-700">
            CARLOS FELIPE
          </p>
          <h2 className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">
            Painel bloqueado
          </h2>
          <p className="mt-4 text-base leading-relaxed text-gray-500 dark:text-gray-400">
            O seu acesso permanece suspenso. Só volta a conseguir usar o painel quando as pendências forem resolvidas. Contacte um Administrador.
          </p>
          <button
            type="button"
            onClick={handleLogout}
            className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-red-700 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-red-800"
          >
            <LogOut size={16} />
            Terminar sessão
          </button>
        </div>
      ) : (
        <div className="flex h-[92vh] w-full max-w-6xl flex-col overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-950">
          <div className="flex-shrink-0 border-b border-zinc-100 px-6 py-5 dark:border-zinc-800 sm:px-10">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-red-700">
              CARLOS FELIPE
            </p>
            <h2 className="mt-1 text-2xl font-bold text-gray-900 dark:text-white">
              Conta bloqueada
            </h2>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto px-4 py-6 sm:px-10 sm:py-8">
            <div
              className="block-html mx-auto w-full max-w-4xl text-lg leading-relaxed text-gray-800 dark:text-gray-100 [&_h1]:mb-4 [&_h1]:text-3xl [&_h1]:font-bold [&_h2]:mb-3 [&_h2]:text-2xl [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-xl [&_h3]:font-semibold [&_img]:mx-auto [&_img]:my-4 [&_img]:max-h-[60vh] [&_img]:w-auto [&_img]:max-w-full [&_img]:rounded-lg [&_p]:mb-4 [&_p]:text-lg"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
          <div className="flex-shrink-0 border-t border-zinc-100 px-6 py-4 dark:border-zinc-800 sm:px-10">
            <button
              type="button"
              onClick={() => setAcknowledged(true)}
              className="w-full rounded-lg bg-zinc-900 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-black dark:bg-white dark:text-zinc-900"
            >
              Compreendo
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
